<template>
  <div class="doctor-box" :class="{'is_null':doctor_list.length == 0}">
    <div class="doctor-top-box" v-if="doctor_list.length>0"></div>
    <loadMore
      class="doctor-load-more"
      v-if="doctor_list.length > 0"
      :onLoadMore="onLoadMore"
      :enableLoadMore="enableLoadMore"
    >
      <div class="doctor-list display_flex_start" v-for="(item,index) in doctor_list" @click="routerPush(item.id)" :key="index">
        <img :src="item.avatar" alt />
        <div class="doctor-detail">
          <div class="doctor-detail-1 flex_s_c">
            <span class="doctor-name font-85">{{item.zname}}</span>
          </div>
          <div class="doctor-detail-2">{{item.position}} | {{item.hospname}}</div>
        </div>
        <div  class="doctor-num is_graphic" v-if="status == 'my'">问诊{{item.is_count == 1?item.count:0}}次</div>
        <div  class="doctor-num is_graphic" v-if="status == 'favorite'">已关注</div>
      </div>
    </loadMore>
    <div class="doctor-null flex_s_c_w" v-if="doctor_list.length == 0">
      <img src="../../../static/icons/shuju@3x.jpg" alt />
      <div class="doctor-null-txt font-85">暂无数据</div>
      <div class="doctor-null-btn" @click="handleToHome">找名医</div>
    </div>
  </div>
</template>
<script>
import http from "../../request/http";
import loadMore from "../loadMore";
export default {
  data() {
    return {
      doctor_list: [],
      enableLoadMore: true,
      page: 1,
      url:'',
      status:''
    };
  },
  created() {
    this.status = this.$route.query.status;
    if(this.$route.query.status == 'my'){
      this.url = '/api/wap/user/mydoctor'
    }
    if(this.$route.query.status == 'favorite'){
      this.url = '/api/wap/user/fandoctor'
    }
    this.getDoctorList();
  },
  components: {
    loadMore,
  },
  methods: {
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return;
        }
        this.page = this.page + 1;
        this.getDoctorList(() => {
          done();
        });
      }, 200);
    },
    getDoctorList(done = function () {}) {
      let data = {
        pageIndex: this.page,
      };
      http
        .post(this.url, data)
        .then((res) => {
          done();
          if (res.data) {
            if (res.data.length < 10) {
              this.enableLoadMore = false;
            }
            if (this.page == 1) {
              this.doctor_list = res.data;
            } else {
              this.doctor_list = this.doctor_list.concat(res.data);
            }
          }else{
            this.doctor_list = []
          }
        })
        .catch((err) => {
          done();
          console.log(err);
        });
    },
    handleToHome() {
      this.$router.push("/");
    },
    routerPush(id){
      this.$router.push("/doctor_main?doctorid=" + id);
    }
  },
};
</script>
<style scoped>
@import "./doctor.css";
.doctor-list{
  padding:1rem;
}
.doctor-list img{
  margin-top: 0.3rem;
}
.doctor-box{
  padding:0;
}
.doctor-load-more {
  height: calc(100vh- 0.5rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;
}
.doctor-list{
  border-bottom: 0.05rem solid #F8F8F8;
}
.doctor-detail{
  width:calc(100% - 2.5rem);
}
.doctor-num{
  position: absolute;
  top:0.55rem;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/my_doctor.vue